import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Field } from 'formik';
import { I18N, I18NConsumer } from 'commons';
import FieldErrorMessage from 'components/forms/FieldErrorMessage';
import * as signUpSelectors from 'state/selectors/signUpSelectors';
import * as locationSelectors from 'state/selectors/locationSelectors';

const AcceptInformation = ({
  values,
  errors,
  handleSubmit,
  isSubmitting,
  signUpError,
  geocodingAddresses,
  isDeleteOperate,
  isAddressVerifyPass,
  setShowAddressVerifyTip,
  validateField,
  addressMandatory,
  isHasPrivateLocation,
  setFieldError,
  setSubmitting
}) => (
  <div className="row">
    <div className="offset-md-3 col-md-5 mt-2">
      <label htmlFor="accept">
        <Field
          name="accept"
          value={values.accept}
          render={({ field }) => (
            <I18NConsumer>
              {(i18n) => (
                <input
                  type="checkbox"
                  title={`${i18n.get('ssp.register.accept1')} ${i18n.get('ssp.register.accept2')}`}
                  checked={field.value}
                  id="accept"
                  {...field}
                />
              )}
            </I18NConsumer>
          )}
        />
        <I18N>ssp.register.accept1</I18N>{' '}
        <a
          rel="noopener noreferrer nofollow"
          href="https://www.everbridge.com/about/legal/everbridge-terms-of-use/"
          target="_blank"
        >
          <I18N>ssp.register.accept2</I18N>
          
        </a>
      </label>
      {!_.isEmpty(signUpError) && <FieldErrorMessage><I18N>{signUpError}</I18N></FieldErrorMessage>}
      <button
        type="submit"
        className="btn btn-primary btn-block mt-3"
        id="new_ssp_create_account"
        onClick={(e) => {
          e.preventDefault();
          validateField();
          if (addressMandatory) {
            if (!isAddressVerifyPass) {
              setShowAddressVerifyTip(true);
              setFieldError('location', 'ssp.map.verify.your.location.errormsg')
            }
          } else if (values.street || values.locationName) {
            if (!isAddressVerifyPass && !isHasPrivateLocation) {
              setShowAddressVerifyTip(true);
              if (values.street && values.locationName) {
                setFieldError('location', 'ssp.map.verify.your.location.errormsg')
              } else {
                setFieldError('location', 'ssp.map.verify.your.location.errormsg.required')
              }
            }
          }
          if (isAddressVerifyPass) {
            setFieldError('location', '')
          }
          return handleSubmit();
        }}
        disabled={
          !values.accept
        }
      >
        <I18N>new.registration.signup.create.account.button.createAccount</I18N>
      </button>
    </div>
  </div>
);

AcceptInformation.propTypes = {
  values: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isHasPrivateLocation: PropTypes.bool.isRequired,
  geocodingAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  signUpError: PropTypes.string,
};

AcceptInformation.defaultProps = {
  signUpError: '',
};

const mapStateToProps = state => ({
  signUpError: signUpSelectors.selectSignUpError(state),
  geocodingAddresses: locationSelectors.selectLocationGeocodingAddresses(state),
});

export default connect(mapStateToProps)(AcceptInformation);
